import { Dialog } from '@mui/material'
import IntegrationsModalBody from './IntegrationsModalBody'
import IntegrationsModalHeader from './IntegrationsModalHeader.jsx'
import { useIntegrationsModal } from './IntegrationsModalContext'
import { useIntegrationsMarketplaceModel } from './useIntegrationsMarketplaceModel'
import styles from './integrationsModal.module.scss'

export default function IntegrationsModal() {
  const { open, closeIntegrations } = useIntegrationsModal()
  const model = useIntegrationsMarketplaceModel()

  return (
    <Dialog
      open={open}
      onClose={closeIntegrations}
      maxWidth={false}
      scroll="paper"
      aria-labelledby="integrations-modal-title"
      slotProps={{
        paper: { className: styles.dialogPaper, elevation: 0 },
      }}
    >
      <IntegrationsModalHeader onClose={closeIntegrations} />
      <IntegrationsModalBody model={model} />
    </Dialog>
  )
}
